var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',_vm._b({staticClass:"hold-switcher",attrs:{"readonly":_vm.readonly},on:{"change":function($event){return _vm.$emit('change', $event)}}},'v-switch',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }